import React from 'react';
import {
  ResourceInventoryEntry,
  TrayInventoryEntry,
  SeedInventoryEntry,
  EntrySource,
  EntryDestination,
} from 'constants/interface';
import {
  InventoryEntryTypeEnum,
  InventoryOutputTypeEnum,
  InventoryTypeEnum,
} from 'constants/inventory';

type GenericEntry = ResourceInventoryEntry | TrayInventoryEntry | SeedInventoryEntry;

interface InventoryEntryTypeLabelProps {
  entry: GenericEntry
}

const OutputTypeFormatterMapping = {
  [InventoryOutputTypeEnum.ADJUSTMENT]: () => 'Ajuste de estoque',
  [InventoryOutputTypeEnum.DISCARD]: () => 'Descarte',
  [InventoryOutputTypeEnum.PRODUCTION]: () => 'Produção',
};

const TransferInFormatterMapping = {
  [InventoryTypeEnum.ORGANIZATION]: (
    source: EntrySource,
  ) => source.name || 'Viveiro',
  [InventoryTypeEnum.CLIENT]: () => 'Cliente',
};

const TransferOutFormatterMapping = {
  [InventoryTypeEnum.ORGANIZATION]: (
    destination: EntryDestination,
  ) => destination.name || 'Viveiro',
  [InventoryTypeEnum.CLIENT]: () => 'Cliente',
};

const EntryTypeFormatterMapping = {
  [InventoryEntryTypeEnum.INPUT]: () => 'Entrada',
  [InventoryEntryTypeEnum.OUTPUT]: (
    // outputType: InventoryOutputTypeEnum,
    entry: GenericEntry,
  ) => `Saída - ${OutputTypeFormatterMapping[
    entry.outputType || InventoryOutputTypeEnum.PRODUCTION
  ]()}`,
  [InventoryEntryTypeEnum.TRANSFER]: () => 'Transferência',
  [InventoryEntryTypeEnum.TRANSFER_IN]: (
    // source: EntrySource,
    entry: GenericEntry,
  ) => `Transferência (Entrada) - ${TransferInFormatterMapping[
    entry.source?.type || InventoryTypeEnum.ORGANIZATION
  ](entry.source || {
    name: '',
    type: InventoryTypeEnum.ORGANIZATION,
    id: '',
  })}`,
  [InventoryEntryTypeEnum.TRANSFER_OUT]: (
    // destination: EntryDestination,
    entry: GenericEntry,
  ) => `Transferência (Saída) - ${TransferOutFormatterMapping[
    entry.destination?.type || InventoryTypeEnum.ORGANIZATION
  ](entry.destination || {
    name: '',
    type: InventoryTypeEnum.ORGANIZATION,
    id: '',
  })}`,
};

const InventoryEntryTypeLabel = ({
  entry,
}: InventoryEntryTypeLabelProps): JSX.Element => {
  let finalType = entry.type;
  if (entry.type === InventoryEntryTypeEnum.OUTPUT && entry.destination) {
    finalType = InventoryEntryTypeEnum.TRANSFER_OUT;
  } else if (entry.type === InventoryEntryTypeEnum.INPUT && entry.source) {
    finalType = InventoryEntryTypeEnum.TRANSFER_IN;
  }
  const formattedType = EntryTypeFormatterMapping[finalType](entry);
  // TODO: maybe use icons
  return (
    <span>{formattedType}</span>
  );
};

export default InventoryEntryTypeLabel;
